<form class="form-popup" [formGroup]="formGroup">
  <div class="modal-body">
          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>Select Job Assignment:</b>
            </div>
            <div class="col-xs-8">
              <aims-lookup style="width:100%"
                           name="SelectJobAssignment"
                           id="selectJobAssignment"
                           [gridText]="'Select a Job Assignment to link to Qualification: ' + qualDesc"
                           [values]="jobAssignmentPuValues | async"
                           [idPropertyName]="'employeeJobAssignmentId'"
                           [displayPropertyName]="'assignmentDescription'"
                           formControlName="employeeJobAssignmentId"
                           [columnsInGrid]="jobAssignmentLookupColumns">
              </aims-lookup>
            </div>
          </div>
  </div>

</form>
